import { motion } from 'framer-motion'

const ITEMS = ['Architecture & Design', 'Residential Construction', 'Industrial Construction', 'PEB Shed Projects', 'Interior Decoration', 'Plot Buying & Selling', 'Project Management', '100% Transparency', 'On Time Delivery', 'Haryana & Delhi NCR']

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS]
  return (
    <div className="ticker-section">
      <div className="ticker-track">
        {doubled.map((item, i) => (
          <div className="ticker-item" key={i}>
            <span className="ticker-dot" />
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}
